// extracted by mini-css-extract-plugin
export default {"cartproductmain":"cart_cartproductmain__Xm6zO","cartproductleft":"cart_cartproductleft__u9Ct6","cartproductright":"cart_cartproductright__zbep8","toprecom":"cart_toprecom__tq7MM"};